import * as React from 'react';

export interface IShowOptionsProps {
	isOpen: boolean;
	options: {
		text: string;
		action: () => void;
	}[];
	closeOptions: () => void;
}

export default class ShowOptions extends React.Component<IShowOptionsProps, {}> {
	constructor(props) {
		super(props);
	}
	containerRef = React.createRef<HTMLDivElement>();

	//////////////////////////////////////////
	// Close options if clicked outside
	//////////////////////////////////////////
	componentDidUpdate() {
		if (this.containerRef && this.containerRef.current) {
			this.containerRef.current.focus();
		}
	}
	//////////////////////////////////////////

	render() {
		const { isOpen, closeOptions, options } = this.props;

		const renderElements = (): JSX.Element[] | null => {
			if (options.length) {
				return options.map((x, index) => (
					<div key={index}>
						<p onClick={x.action} className="pointer">
							{x.text}
						</p>
					</div>
				));
			}
			return null;
		};

		return (
			<>
				{isOpen ? (
					<div ref={this.containerRef} tabIndex={0} onBlur={closeOptions} className="showOptionsContainer">
						{renderElements()}
					</div>
				) : null}
			</>
		);
	}
}
